module.exports = __webpack_public_path__ + "img/header-engagementRingsPrincess.295aa06.jpg";